import VisitService from 'Services/VisitService'
import IssueService from 'Services/IssueService'
import AttachmentsService from 'Services/AttachmentsService'
import DefaultIssueService from 'Services/DefaultIssueService'
import moment from "moment/moment";

export default {

    state: {
        plannedVisits: [],
        visits: [],
        visit: {
            issue_id: null,
            issue_status: null,
            accompanying_diseases: null,
            family_interview: null,
            activities_generating_problem: null,
            movement_disorder: null,
            factors_causing_deterioration: null,
            factors_causing_improvement: null,
            taken_medicines: null,
            additional_information: null,
            range_of_motion: null,
            muscular_strength: null,
            circuit_measurement: null,
            map_of_pain: null,
            recognition: null,
            therapy_being_performed: null,
            exercises: null,
            attention_to_exercises: null,
            plan_of_works: null,
            recommendations: null,
            videos_with_exercises: null,
            patient_email_for_recommendations: null,
            custom_fields: null,
            event: {}
        },
        visitP1Reports: [],
        lastVisit: null,
        visitDefaultIssues: [],
        visitIssues: [],
        visitIssue: null,
        fieldHistory: [],
        visitAttachmentsFormal: [],
        visitAttachmentsDiagnostic: []
    },

    getters: {
        visits: state => state.visits,
        visit: state => state.visit,
        visitP1Reports: state => state.visitP1Reports,
        lastVisit: state => state.lastVisit,
        plannedVisits: state => state.plannedVisits,
        visitDefaultIssues: state => state.visitDefaultIssues,
        visitIssues: state => state.visitIssues,
        visitIssue: state => state.visitIssue,
        fieldHistory: state => state.fieldHistory,
        visitAttachmentsFormal: state => state.visitAttachmentsFormal,
        visitAttachmentsDiagnostic: state => state.visitAttachmentsDiagnostic,
    },

    mutations: {
        SET_VISIT(state, visit) {
            state.visit = visit
        },
        SET_VISIT_P1_REPORTS(state, visitP1Reports) {
            visitP1Reports = visitP1Reports.map((visitP1Report) => {
                visitP1Report.created_at = moment(visitP1Report.created_at).format('DD.MM.YYYY HH:mm:ss');
                visitP1Report.updated_at = moment(visitP1Report.updated_at).format('DD.MM.YYYY HH:mm:ss');
                return visitP1Report;
            })
            state.visitP1Reports = visitP1Reports
        },
        SET_LAST_VISIT(state, lastVisit) {
            state.lastVisit = lastVisit
        },
        SET_VISITS(state, visits) {
            state.visits = visits
        },
        SET_ISSUE(state, issue) {
            state.visitIssue = issue
        },
        SET_ISSUES(state, visitIssues) {
            state.visitIssues = visitIssues
        },
        SET_DEFAULT_ISSUES(state, visitDefaultIssues) {
            state.visitDefaultIssues = visitDefaultIssues
        },
        SET_FIELD_HISTORY(state, history) {
            state.fieldHistory = history
        },
        SET_ATTACHMENTS(state, data) {
            if (data.type === 'formal-documents')
                state.visitAttachmentsFormal = data.data
            else if (data.type === 'diagnostic-tests')
                state.visitAttachmentsDiagnostic = data.data
        },
        REMOVE_VISIT(state, visitId) {
            state.visits = state.visits.filter((visit) => {
                return visit.id !== visitId
            })
        },
    },

    actions: {
        VISITS_FETCH(context, query) {
            return VisitService.list(query).then((response) => {
                context.commit('SET_VISITS', response.data.data.data)
                context.dispatch('CREATE_PAGINATION', response.data.data.last_page)
                return response
            })
        },
        VISIT_FETCH(context, visitId) {
            return VisitService.get(visitId).then((response) => {
                context.commit('SET_VISIT', response.data.data)
                return response
            })
        },
        VISIT_END(context, visitId) {
            return VisitService.end(visitId)
        },
        VISIT_P1_REPORTS_FETCH(context, visitId) {
            return VisitService.getP1Reports(visitId).then((response) => {
                context.commit('SET_VISIT_P1_REPORTS', response.data.data)
                return response
            })
        },
        VISIT_LAST_FETCH(context) {
            return VisitService.last(context.state.visit.issue_id).then((response) => {
                context.commit('SET_LAST_VISIT', response.data.data)
                return response
            }).catch(() => {
                // if last visit doesn't exist is still okey
                Promise.resolve()
            })
        },
        VISIT_LAST_RESET(context) {
            context.commit('SET_LAST_VISIT', null)
        },
        VISIT_CREATE(context, data) {
            return VisitService.create(data).then((response) => {
                context.commit('SET_VISIT', response.data.data)
                return response
            })
        },
        VISIT_DELETE(context, visitId) {

            return VisitService.delete(visitId).then((response) => {
                context.commit('REMOVE_VISIT', visitId)
                return response
            })
        },

        VISIT_FIELD_UPDATE(context, data) {
            return VisitService.updateField(data.id, data.value, data.field).then((response) => {
                context.commit('SET_VISIT', response.data.data)
                return response
            })
        },
        VISIT_FIELD_HISTORY_FETCH(context, field) {
            return VisitService.history(context.state.visit.id, field).then((response) => {
                context.commit('SET_FIELD_HISTORY', response.data.data)
                return response
            })
        },

        VISIT_FIELD_HISTORY_RESET(context) {
            context.commit('SET_FIELD_HISTORY', [])
        },

        VISIT_DEFAULT_ISSUES_FETCH({commit}) {
            return DefaultIssueService.list({
                paginate: 0
            }).then((result) => {
                commit('SET_DEFAULT_ISSUES', result.data.data)
                return result
            })
        },

        VISIT_ISSUES_FETCH(context, patientId) {
            const query = {
                patient_id: patientId,
                paginate: 0
            }

            return IssueService.list(query).then((result) => {
                context.commit('SET_ISSUES', result.data.data)
                return result
            })
        },

        VISIT_ISSUE_FETCH(context, issueId) {
            return IssueService.get(issueId).then((result) => {
                context.commit('SET_ISSUE', result.data.data)
                return result
            })
        },

        VISIT_ISSUE_STORE(context, issue) {
            return IssueService.store(issue)
        },

        VISIT_ISSUE_UPDATE(context, issue) {
            return IssueService.update(issue).then((result) => {
                context.commit('SET_ISSUE', result.data.data)
                return result
            })
        },

        VISIT_ATTACHMENTS_FETCH(context, data) {
            return AttachmentsService.list(data.visitId, data.type).then((response) => {
                context.commit('SET_ATTACHMENTS', {
                    data: response.data.data,
                    type: data.type
                })
                return response
            })
        },

        VISIT_ATTACHMENTS_UPLOAD(context, data) {
            return AttachmentsService.upload(context.state.visit.id, data.type, data).then((response) => {
                context.dispatch('VISIT_ATTACHMENTS_FETCH', {
                    visitId: context.state.visit.id,
                    type: data.type
                })
                return response
            })
        },

        VISIT_ATTACHMENTS_DELETE_DOWNLOAD(context, data) {
            return AttachmentsService.download(context.state.visit.id, data.type, data.id)
        },

        VISIT_ATTACHMENTS_DELETE(context, data) {
            return AttachmentsService.delete(context.state.visit.id, data.type, data.id).then((response) => {
                context.dispatch('VISIT_ATTACHMENTS_FETCH', {
                    visitId: context.state.visit.id,
                    type: data.type
                })
                return response
            })
        },

        VISIT_ISSUE_DELETE(context, issueId) {
            return IssueService.delete(issueId)
        },
    }

}
